import * as Yup from 'yup';

export const MaterialSchema = Yup.object().shape({
  label: Yup.string().required('Libellé requis'),
  codingConfig: Yup.object()
    .shape({
      code: Yup.string().required('Code requis'),
    })
    .required('Code requis'),
  costUsages: Yup.array().of(
    Yup.object()
      .shape({
        quantity: Yup.object().shape({
          value: Yup.number()
            .required('Quantité requise')
            .moreThan(0, 'La quantité doit être supérieure à 0'),
          unitId: Yup.string().required('Unité requise'),
        }),
      })
      .required('Quantité requise'),
  ),
});
